export enum DashboardComponentType {
  Undefined = 0,
  StorageAreaTable = 1,
  LatestReleaseNotes = 2,
  ProductGroupDiagram = 3,
  ProductGroupTable = 4,
  ProductTable = 5,
  AsljungapallenLagersaldo = 6,
}
